import { ArrowRight, Inbox } from "lucide-react";
import { formatDate, relativeDate } from "../lib/format";
import { Link } from "../lib/router";
import type { TicketSummary } from "../types/api";
import { PriorityBadge, StatusBadge } from "./StatusBadge";
import { Skeleton } from "./ui";

export function TicketTable({
  tickets,
  loading,
  compact = false,
}: {
  tickets?: TicketSummary[];
  loading?: boolean;
  compact?: boolean;
}) {
  if (loading) {
    return (
      <div className="space-y-3 p-5">
        {Array.from({ length: compact ? 5 : 8 }).map((_, index) => (
          <Skeleton key={index} className="h-16 w-full rounded-xl" />
        ))}
      </div>
    );
  }

  if (!tickets?.length) {
    return (
      <div className="empty-state">
        <span>
          <Inbox className="size-6" />
        </span>
        <h3>Nenhum chamado encontrado</h3>
        <p>Tente ajustar os filtros ou abra uma nova solicitação.</p>
      </div>
    );
  }

  return (
    <div className="ticket-table-wrap">
      <table className="ticket-table">
        <thead>
          <tr>
            <th>Chamado</th>
            <th>Status</th>
            {!compact && <th>Prioridade</th>}
            <th className="hidden xl:table-cell">Solicitante</th>
            <th>Atualização</th>
            <th aria-label="Ações" />
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket) => (
            <tr key={ticket.numero}>
              <td>
                <Link to={`/chamados/${ticket.numero}`} className="ticket-main">
                  <span>#{ticket.numero}</span>
                  <strong>{ticket.categoria || "Solicitação de suporte"}</strong>
                  <small>{formatDate(ticket.dtAbertura)}</small>
                </Link>
              </td>
              <td>
                <StatusBadge status={ticket.ultimoStatus} compact />
              </td>
              {!compact && (
                <td>
                  <PriorityBadge priority={ticket.prioridade} />
                </td>
              )}
              <td className="hidden xl:table-cell">
                <div className="table-person">
                  <span>{ticket.usuario?.slice(0, 1).toUpperCase() || "U"}</span>
                  <div>
                    <strong>{ticket.usuario || "Usuário"}</strong>
                    <small>{ticket.empresa}</small>
                  </div>
                </div>
              </td>
              <td>
                <span className="table-date">
                  {relativeDate(ticket.dtUltimaAtua || ticket.dtAbertura)}
                </span>
              </td>
              <td>
                <Link
                  to={`/chamados/${ticket.numero}`}
                  className="table-arrow"
                  aria-label={`Abrir chamado ${ticket.numero}`}
                >
                  <ArrowRight className="size-[18px]" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
